export function getConfig (config) {
  let environmentConfiguration = {
    "cloudinaryBaseUrl": "https://assets.icanet.se",
    "searchUrl": "https://iw01dazweweb002.azure.icacorp.net",
    "recipeExperienceApiBaseUrl": "https://apimgw-pub.ica.se/t/public.tenant/ica-recipe-experience/v1",
    "customerDataApiBaseUrl": "https://apimgw-pub.ica.se/t/public.tenant/digx/customer-data/v1/customers/me",
    "cookieSubDomain": ".ica.se",
    "loginEndpointUrl": "http://login-test.ica.ia-hc.net/logga-in/sso/",
    "onlineScriptSrc": ""
  }

  if (SSR_MODE && config) {
    environmentConfiguration = config
  } else if (window && window._vueContext && window._vueContext.envConfig) {
    environmentConfiguration = window._vueContext.envConfig
  }

  return environmentConfiguration
}
